import { UpdateAccountErrorKeys, UpdateAccountErrorListKeys, UpdateAccountHeaderErrorKeys } from "../../login/components/UpdateAccountSection";
import { UpdateAccoutError } from "../hooks/useUpdateAccountApi";
import { ApiError, hasInvalidField } from "./getApiErrorMessage";

interface Props {
    updateAccountResponse: {
        code: number;
        errors: UpdateAccoutError[];
    }
    setApiErrorHeaderKey: React.Dispatch<React.SetStateAction<UpdateAccountHeaderErrorKeys | null>>
    setApiErrorKey: React.Dispatch<React.SetStateAction<UpdateAccountErrorKeys | null>>
    setAnalyticsKey: React.Dispatch<React.SetStateAction<UpdateAccountErrorKeys | UpdateAccountErrorListKeys | "unknownError" | undefined>>
    setApiErrorListKey: React.Dispatch<React.SetStateAction<UpdateAccountErrorListKeys | null>>
    setAlreadyUsed: React.Dispatch<React.SetStateAction<boolean>>
}

export const handle400Errors = (props: Props) => {
    const { 
        updateAccountResponse,
        setApiErrorHeaderKey, 
        setApiErrorKey, 
        setAnalyticsKey, 
        setApiErrorListKey,
        setAlreadyUsed,
    } = props;
    const isAlreadyUsed = updateAccountResponse.errors?.some((error: ApiError) => error.name === 'AlreadyUsed');
    const invalidUsername = hasInvalidField(updateAccountResponse.errors, 'username') || hasInvalidField(updateAccountResponse.errors, 'updates.username');
    const invalidPassword = hasInvalidField(updateAccountResponse.errors, 'password');
    const invalidUpdatesPassword = hasInvalidField(updateAccountResponse.errors, 'updates.password');
    const invalidChallengeQuestionAndAnswers = hasInvalidField(updateAccountResponse.errors, 'updates.challengeQuestionAndAnswers');
    const invalidLang = hasInvalidField(updateAccountResponse.errors, 'lang');
    const invalidUpdates = hasInvalidField(updateAccountResponse.errors, 'updates');
    const notFound = updateAccountResponse.errors?.some((error: ApiError) => error.message && error.message.includes('user not found'));

    if (hasInvalidField(updateAccountResponse?.errors, 'updates.email')) {
        setApiErrorHeaderKey('completeItems');
        setApiErrorListKey('enterEmail');
        setAnalyticsKey('enterEmail');
    } else if (isAlreadyUsed) {
        setAlreadyUsed(true);
        // newPasswordErrorSetter(true);
        // confirmNewPasswordErrorSetter(true);
        setApiErrorHeaderKey('completeItems');
        setApiErrorListKey('enterPassword');
        setAnalyticsKey('enterPassword');
    } else if (invalidUsername) {
        setApiErrorHeaderKey('completeItems');
        setApiErrorListKey('createUsername');
        setAnalyticsKey('createUsername');
    } else if (invalidPassword) {
        setApiErrorHeaderKey('completeItems');
        setApiErrorListKey('checkPassword');
        setAnalyticsKey('checkPassword');
    } else if (invalidUpdatesPassword) {
        setApiErrorHeaderKey('completeItems');
        setApiErrorListKey('createPassword');
        setAnalyticsKey('createPassword');
    } else if (invalidChallengeQuestionAndAnswers) {
        setApiErrorHeaderKey('completeItems');
        setApiErrorListKey('question');
        setApiErrorListKey('answer');
        setAnalyticsKey('question');
        setAnalyticsKey('answer');
    } else if (invalidLang || invalidUpdates) {
        setApiErrorHeaderKey('cantProcess');
        setApiErrorKey('inconvenience');
        setAnalyticsKey('inconvenience');
    } else if (notFound) {
        setApiErrorHeaderKey('cantFind');
        setApiErrorKey('tryAgain');
        setAnalyticsKey('tryAgain');
    } else {
        setApiErrorHeaderKey('completeItems');
        setApiErrorKey('inconvenience');
        setAnalyticsKey('inconvenience');
    }
}